// extracted by mini-css-extract-plugin
module.exports = {"cardHeadline":"roleAssignment_cardHeadline__MTLPo","cardDescription":"roleAssignment_cardDescription__2f07I","subscriptionSelector":"roleAssignment_subscriptionSelector__3-Cvc"};